module.exports = __webpack_public_path__ + "img/external-link.19c50984.svg";